import { DataStatus, Message, MessageType } from '@wearejh/m2-pwa-engine/lib/types';
import { errorMessage } from '@wearejh/m2-pwa-engine';

import { Actions } from './cart.actions';

import { CartItem, CartTotals } from './index';

export enum CartVariant {
    Guest = 'Guest',
    Account = 'Account',
}

export type CartState<T extends any = Record<string, any>> = {
    status: DataStatus;

    cartId: string | null;
    items_qty: number;
    totals: CartTotals | null;
    items: CartItem[];

    messages: Message[];
    itemMessages: Message[];
    deleting: number[];
    updating: number[];

    raw: null | T;
};

const initialState: CartState = {
    status: DataStatus.Idle,
    cartId: null,

    items_qty: 0,
    totals: null,

    items: [],
    messages: [],
    itemMessages: [],
    deleting: [],
    updating: [],
    raw: null,
};
export const initialCartState = initialState;

export type AppendState<T = {}> = T & { cart: CartState };
export type AppendCartState<T = {}> = T & { cart: CartState };

export function cartState(state = initialState, action: Actions): CartState {
    switch (action.type) {
        case 'Cart.Reset': {
            return {
                ...initialState,
            };
        }
        case 'Cart.Add':
        case 'Cart.Add.Config':
        case 'Cart.Add.Simple': {
            return {
                ...state,
                status: DataStatus.Pending,
            };
        }
        case 'Cart.AddError': {
            return {
                ...state,
                status: DataStatus.Success,
                messages: [errorMessage(action.payload)],
            };
        }
        case 'Cart.FetchError': {
            return {
                ...state,
                status: DataStatus.Error,
                messages: [errorMessage(action.payload)],
            };
        }
        case 'Cart.ClearMessages': {
            return {
                ...state,
                status: DataStatus.Success,
                messages: [],
            };
        }
        case 'Cart.SetStatus': {
            return {
                ...state,
                status: action.payload,
            };
        }
        case 'Cart.ClearAllItemMessages': {
            return {
                ...state,
                messages: [],
                itemMessages: [],
            };
        }
        case 'Cart.ItemDelete':
        case 'Cart.ItemUpdate': {
            return {
                ...state,
                status: DataStatus.Pending,
                messages: [],
                itemMessages: [],
            };
        }
        case 'Cart.ItemDeleteError':
        case 'Cart.ItemUpdateError': {
            return {
                ...state,
                status: DataStatus.Error,
                messages: [],
                itemMessages: [errorMessage(action.payload)],
            };
        }

        case 'Cart.HydrateFromLocalStorage': {
            return {
                ...state,
                ...action.payload,
                status: DataStatus.Success,
            };
        }
        case 'Cart.CreateEmptyError': {
            return {
                ...initialState,
                status: DataStatus.Error,
                messages: [
                    {
                        type: MessageType.Error,
                        text: action.payload,
                    },
                ],
            };
        }
        case 'Cart.Fetch': {
            return {
                ...state,
                status: DataStatus.Pending,
            };
        }
        case 'Cart.CreateEmptySuccess':
        case 'Cart.FetchSuccess': {
            const { totals, items, items_qty, cartId, raw } = action.payload;
            return {
                ...state,
                cartId,
                totals,
                items,
                items_qty,
                status: DataStatus.Success,
                deleting: [],
                updating: [],
                messages: [],
                itemMessages: [],
                raw,
            };
        }
        default: {
            return state;
        }
    }
}
